import useDimensions from './useDimensions';

export default useDimensions;
